<template>
  <div class="login-view w-100 h-100">
    <div class="login-container w-100 h-100 d-flex flex-align-center">
      <div class="form">
        <div class="form-container p-3">
          <div class="greeting">BoLiCa</div>
          <transition name="fast-fade" mode="out-in">
            <div v-if="isBusy">
              <Spinner size="64" />
            </div>
            <form class="register-form" v-else-if="registerForm" key="register">
              <input type="text" placeholder="Имя" id="name" name="name" v-model="regName" />
              <input
                type="password"
                placeholder="Пароль"
                id="password"
                name="password"
                v-model="regPassword"
                @keypress.enter="register()"
              />
              <input type="text" placeholder="Почта (необязательно)" id="email" name="email" v-model="regMail" />

              <Button title="Создать" class="action-button green w-100" @click="register()" />
              <p class="message text-center">
                Уже зарегестрированы?
                <a href="#" @click.prevent="switchForm()">Войти</a>
              </p>
            </form>
            <form class="login-form" v-else key="login">
              <p class="error ph-1 mt-0">{{ error }}</p>
              <input
                type="text"
                placeholder="Имя или почта"
                id="name"
                name="name"
                v-model="name"
                ref="loginInput"
                @keypress.enter="focusPassword()"
              />
              <input
                type="password"
                placeholder="Пароль"
                id="password"
                name="password"
                v-model="password"
                @keypress.enter="login()"
                ref="passwordInput"
              />

              <Button title="Войти" class="action-button green w-100 text-uppercase" @click="login()" />
              <hr class="hr-text" data-content="или через" />
              <grid columns="1" gap=".5">
                <c>
                  <Button title="Google" class="action-button gray text-uppercase w-100" @click="signinWithGoogle()" />
                </c>
              </grid>
              <!--
              <p class="message text-center">
                Не зарегестрированы?
                <a href="#" @click.prevent="switchForm()">Создать аккаунт</a>
              </p>
              -->
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASE_API_URL } from "../common/urls";
export default {
  data() {
    return {
      isBusy: false,
      error: "",
      name: "",
      password: "",
      regName: "",
      regPassword: "",
      regMail: "",
      registerForm: false
    };
  },
  methods: {
    focusLogin() {
      const loginInput = this.$refs.loginInput;
      if (loginInput) {
        loginInput.focus();
      }
    },
    focusPassword() {
      const passwordInput = this.$refs.passwordInput;
      if (passwordInput) {
        passwordInput.focus();
      }
    },
    async login() {
      this.error = null;
      if (!this.name) {
        this.error = "Нужно указать имя или почту";
        return;
      }
      if (!this.password) {
        this.error = "Нужно указать пароль";
        return;
      }
      try {
        this.isBusy = true;
        await this.$store.dispatch("users/signin", {
          password: this.password,
          name: this.name
        });
      } catch (ex) {
        if (ex.message) {
          this.error = ex.message;
        } else {
          this.error = "Не верно указаны имя/почта или пароль";
        }
      } finally {
        this.isBusy = false;
      }
    },
    signinWithGoogle() {
      localStorage.removeItem("google.oauth2");

      const self = this;
      self.isBusy = true;
      const loginWindow = window.open(
        `${BASE_API_URL}/auth/google`,
        "",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=800, height=600"
      );

      window.addEventListener("message", (event) => {
        if (event.origin == `${BASE_API_URL}`) {
          const value = event.data;
          loginWindow.close();
          const googleInfo = value ? JSON.parse(value) : null;
          if (googleInfo) {
            self.$store.dispatch("users/getUser").catch((ex) => {
              if (ex.message) {
                self.error = ex.message;
              } else {
                self.error = "Не удалось войти через Google";
              }
            });
          } else {
            self.error = "Сначала нужно войти в Google";
          }
          self.isBusy = false;
        }
      });

      const queryInterval = setInterval(() => {
        if (!loginWindow || loginWindow.closed) {
          clearInterval(queryInterval);
          self.isBusy = false;
          return;
        }

        loginWindow.postMessage("google.oauth2", `${BASE_API_URL}/auth/google/callback`);
      }, 500);
    },
    register() {
      this.$snotify.error(`Не реализовано еще пока что..`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    switchForm() {
      if (this.registerForm) {
        if (!this.name) this.name = this.regName;
        if (!this.regPassword) this.password = this.regPassword;
        this.registerForm = false;
      } else {
        if (!this.regName) this.regName = this.name;
        if (!this.regLogin) this.regLogin = this.password;
        this.registerForm = true;
      }
    }
  },
  mounted() {
    this.focusLogin();
  }
};
</script>
<style lang="postcss">
.login-view {
  background: var(--color-blue);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .login-container {
    .form {
      max-width: 420px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);

      .error {
        color: red;
      }
      .greeting {
        color: var(--color-black);
        padding-bottom: 15px;
        text-align: center;
        font-size: 3em;
      }
      input {
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
        color: var(--color-black);
      }

      .action-button {
        padding: 15px;
      }
      .message {
        margin: 15px 0 0;
        color: #b3b3b3;
        font-size: 12px;

        a {
          color: var(--color-blue);
          text-decoration: none;
        }
      }

      .hr-text {
        line-height: 1em;
        position: relative;
        outline: 0;
        border: 0;
        color: black;
        text-align: center;
        height: 1.5em;
        opacity: 0.5;
        &:before {
          content: "";
          background: linear-gradient(to right, transparent, #818078, transparent);
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          height: 1px;
        }
        &:after {
          content: attr(data-content);
          position: relative;
          display: inline-block;
          color: black;

          padding: 0 0.5em;
          line-height: 1.5em;
          color: #818078;
          background-color: #fcfcfa;
        }
      }
    }
  }
}

/* desktop */
@media screen and (min-width: 800px) {
  .login-view {
    .login-container {
      .form {
      }
    }
  }
}
</style>
